import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 1,
  class: "icon-container"
}
const _hoisted_3 = { class: "multiselect__tag" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 2,
  class: "error-msg caption"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-container", [_ctx.customClass, _ctx.required && 'required']])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id,
          class: _normalizeClass({ active: _ctx.isActive, icon: _ctx.icon })
        }, [
          _createVNode(_component_TranslatedText, { path: _ctx.label }, null, 8, ["path"])
        ], 10, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_font_awesome_icon, {
            class: "icon",
            icon: _ctx.icon
          }, null, 8, ["icon"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_VueMultiselect, _mergeProps({
      ref: `multiSelect-${_ctx.name}`,
      placeholder: _ctx.getPlaceholder,
      modelValue: _ctx.valueArray,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valueArray) = $event)),
      options: _ctx.selectOptions,
      multiple: false,
      disabled: _ctx.disabled,
      "close-on-select": true,
      "allow-empty": !_ctx.required,
      "show-labels": false,
      label: _ctx.labelField,
      "track-by": _ctx.valueField,
      maxHeight: 200,
      searchable: _ctx.searchable
    }, _ctx.additionalAtrributes, {
      class: {
        error: !!_ctx.error,
        icon: _ctx.icon,
      },
      onRemove: _ctx.handleRemove,
      onSelect: _ctx.handleChange,
      onSearchChange: _ctx.handleSearchChange
    }), {
      tag: _withCtx(({ option, remove }) => [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(option.group ? option.group + ": " : "") + _toDisplayString(option.name), 1),
          _createElementVNode("i", {
            tabindex: "1",
            class: "multiselect__tag-icon",
            onClick: ($event: any) => (remove(option))
          }, null, 8, _hoisted_4)
        ])
      ]),
      noResult: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode(" No matching results ", -1)
      ]))]),
      _: 1
    }, 16, ["placeholder", "modelValue", "options", "disabled", "allow-empty", "label", "track-by", "searchable", "class", "onRemove", "onSelect", "onSearchChange"]),
    (_ctx.error && !_ctx.isFocussed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_TranslatedText, { path: _ctx.error }, null, 8, ["path"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}